import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-5" }
const _hoisted_2 = { class: "fs-2 fw-bold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gem text-warning me-2" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-10 text-center"
}
const _hoisted_5 = { class: "row g-6 g-xl-9" }
const _hoisted_6 = {
  key: 0,
  class: "row mt-10"
}
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = {
  class: "",
  role: "alert"
}
const _hoisted_9 = { class: "alert-heading" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_12 = { class: "text-gray-500" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { class: "text-gray-500" }, " Nenhum desafio encontrado para este torneio. ")
], -1)
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "card-header border-0 pt-9" }
const _hoisted_16 = { class: "card-toolbar" }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-light-primary fw-bolder me-auto px-4 py-3"
}
const _hoisted_18 = {
  key: 1,
  class: "badge badge-light-success fw-bolder me-auto px-4 py-3"
}
const _hoisted_19 = {
  key: 2,
  class: "badge badge-light-warning fw-bolder me-auto px-4 py-3"
}
const _hoisted_20 = { class: "card-body pt-4 p-9" }
const _hoisted_21 = { class: "fs-3 fw-bolder text-dark d-flex justify-content-center" }
const _hoisted_22 = { class: "dificulty mb-5 mt-3 d-flex justify-content-center" }
const _hoisted_23 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_24 = {
  key: 1,
  class: "badge badge-light-info"
}
const _hoisted_25 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_26 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fw-bold fs-5 mt-1 mb-7" }, null, -1)
const _hoisted_28 = { class: "dificulty mb-5 mt-3 d-flex justify-content-center gap-2" }
const _hoisted_29 = { class: "d-flex flex-wrap mb-5 justify-content-center" }
const _hoisted_30 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-7 mb-3" }
const _hoisted_31 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_32 = { class: "fw-bold text-gray-500" }
const _hoisted_33 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3" }
const _hoisted_34 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_35 = { class: "fw-bold text-gray-500" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gem text-warning" }, null, -1)
const _hoisted_37 = {
  class: "h-4px w-100 bg-light mb-5",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "This project completed"
}
const _hoisted_38 = ["aria-valuenow"]
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "text-gray-600 fs-6" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-shield" }, null, -1)
const _hoisted_43 = { class: "symbol-group symbol-hover justify-content-center" }
const _hoisted_44 = {
  class: "symbol symbol-35px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "Creator"
}
const _hoisted_45 = ["src", "title"]
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("small", { class: "text-gray-600 fs-6" }, [
  /*#__PURE__*/_createTextVNode("First Blood "),
  /*#__PURE__*/_createElementVNode("i", { class: "las la-tint text-danger" })
], -1)
const _hoisted_48 = { class: "symbol-group symbol-hover justify-content-center" }
const _hoisted_49 = {
  class: "symbol symbol-35px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "First Blood"
}
const _hoisted_50 = ["src", "title"]
const _hoisted_51 = { class: "pagination pagination-outline mt-10" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = {
  key: 1,
  class: "justify-content-center d-flex flex-center"
}
const _hoisted_55 = {
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_56 = { class: "sr-only" }

import router from "@/router";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from 'vue-i18n'
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import moment from "moment";
import { IChallengeMetadata } from "@/types/ChallengeType";


export default /*#__PURE__*/_defineComponent({
  props: {
    tournament_id: null
  },
  setup(__props: any) {

const props = __props as {
  tournament_id: string
}



const store = useStore();

const { t } = useI18n()
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

const loading = ref(true)

const query: any = router.currentRoute.value.query;
const page: number = query.page ? parseInt(query?.page) : 1;

const challenges = ref([]) as any;
const currentMetadata = ref({ links: [] }) as IChallengeMetadata;

const tournamentNames: Record<string, string> = {
  '3': 'CarnavOwn 2026',
  '4': 'Copa 2026',
  '5': 'Final Copa 2026'
};

const tournamentName = computed(() => tournamentNames[props.tournament_id] || `Torneio ${props.tournament_id}`);

onMounted(async () => {
  setCurrentPageTitle(`Desafios - ${tournamentName.value}`);

  await store.dispatch(Actions.GET_TOURNAMENT_CHALLENGES, {
    tournament_id: Number(props.tournament_id),
    page: page
  });

  challenges.value = store.getters.getChallenges;
  currentMetadata.value = store.getters.getChallengesMetadata;

  loading.value = false
});

const goTo = async (url: string) => {
  if (url) {
    const page = url.split("page=")[1];
    window.history.pushState({}, "", `/training/carnavown?page=${page}`);

    loading.value = true;
    await store.dispatch(Actions.GET_TOURNAMENT_CHALLENGES, {
      tournament_id: Number(props.tournament_id),
      page: page
    });
    challenges.value = store.getters.getChallenges;
    currentMetadata.value = store.getters.getChallengesMetadata;
    loading.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_unref(tournamentName)) + " - Desafios ", 1)
      ])
    ]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(challenges).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h4", _hoisted_9, [
                        _hoisted_10,
                        _hoisted_11,
                        _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.no_machines_found`)), 1)
                      ]),
                      _hoisted_13
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(challenges), (challenge) => {
              return (_openBlock(), _createElementBlock("div", {
                key: challenge.id,
                class: "col-md-6 col-xl-4"
              }, [
                _createElementVNode("a", {
                  href: '/training/challenges/' + challenge.id,
                  class: "card border-hover-primary",
                  style: {"cursor":"pointer","height":"400px"}
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (challenge?.percentage > 0 && challenge?.percentage < 100)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.in_progress`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.percentage == 100)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.completed`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.percentage == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.not_started_yet`)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(challenge?.name), 1),
                    _createElementVNode("div", _hoisted_22, [
                      (challenge?.dificulty == 'easy')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.easy`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.dificulty == 'medium')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.medium`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.dificulty == 'hard')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hard`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.dificulty == 'insane')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.insane`)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(challenge?.categories, (category) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: category.id,
                          class: "badge border border-gray-300 border-dashed rounded py-3 px-2 text-gray-800 justify-content-center"
                        }, _toDisplayString(category.name), 1))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(moment).utc(challenge?.release_at).format("DD MMMM, YYYY")), 1),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.release_date`)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(challenge.points), 1),
                        _createElementVNode("div", _hoisted_35, [
                          _createTextVNode("Total " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.of`)) + " XP ", 1),
                          _hoisted_36
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", {
                        class: "bg-primary rounded h-4px",
                        role: "progressbar",
                        style: _normalizeStyle('width: ' + challenge?.percentage + '%'),
                        "aria-valuenow": challenge?.percentage,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, null, 12, _hoisted_38)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("small", _hoisted_41, [
                          _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.creator`)) + " ", 1),
                          _hoisted_42
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("img", {
                              alt: "Pic",
                              src: challenge?.creator ? challenge?.creator?.profile_photo_path : '/media/avatars/blank.png',
                              title: challenge?.creator?.nick ? challenge?.creator?.nick : 'no nick'
                            }, null, 8, _hoisted_45)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("img", {
                              alt: "Pic",
                              src: challenge?.first_blood?.avatar ? challenge?.first_blood?.avatar : '/media/avatars/blank.png',
                              title: challenge?.first_blood?.nick ? challenge?.first_blood?.nick : 'no blood'
                            }, null, 8, _hoisted_50)
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 8, _hoisted_14)
              ]))
            }), 128)),
            _createElementVNode("ul", _hoisted_51, [
              (_unref(currentMetadata)?.links)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(currentMetadata).links, (link) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: link.label
                    }, [
                      _createElementVNode("li", {
                        class: _normalizeClass('page-item m-1 cursor-pointer ' + (link.active ? 'active' : ''))
                      }, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (goTo(link.url)),
                          class: "page-link"
                        }, [
                          _createElementVNode("span", {
                            innerHTML: link.label
                          }, null, 8, _hoisted_53)
                        ], 8, _hoisted_52)
                      ], 2)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "...", 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})